import { render } from "./BaseListItem.vue?vue&type=template&id=eedd1520&ts=true"
import script from "./BaseListItem.vue?vue&type=script&lang=ts"
export * from "./BaseListItem.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__